<template>
  <div class="banat">
    <h1>Banat</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/bana_2kl.jpg" width="125" border="0" height="110" alt="Banat: Bahnstation mit rumänischer und ukrainischer Beschriftung"
        @click="callImageClick('Banat: Bahnstation mit rumänischer und ukrainischer Beschriftung', 'bana_2.jpg', $event)">
						<br>Banat: Bahnstation mit rumänischer und ukrainischer Beschriftung
      </div>
      <div class="foto">
        <img src="../assets/fotos/bana_3kl.jpg" width="125" border="0" height="110" alt="neues Kloster im Banat"
        @click="callImageClick('neues Kloster im Banat', 'bana_3.jpg', $event)">
						<br>neues Kloster im Banat
      </div>
      <div class="foto">
        <img src="../assets/fotos/bana_4kl.jpg" width="125" border="0" height="110" alt="neues Kloster im Banat"
        @click="callImageClick('neues Kloster im Banat', 'bana_4.jpg', $event)">
						<br>neues Kloster im Banat
      </div>
      <div class="foto">
        <img src="../assets/fotos/bana_5kl.jpg" width="125" border="0" height="110" alt="Banat: Roma-Villa"
        @click="callImageClick('Banat: Roma-Villa', 
        'bana_5.jpg', $event)">
				<br>Banat: Roma-Villa
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>